import { ComponentProps } from 'react';
import { useIntl } from '@alltrails/shared/react-intl';
import CustomProvider from 'components/CustomProvider';
import SearchOrigin from '@alltrails/analytics/enums/SearchOrigin';
import { AlgoliaSearchBox } from '@alltrails/modules/AlgoliaSearch';
import '@alltrails/modules/AlgoliaSearch/index.css';

type AlgoliaSearchBoxProps = ComponentProps<typeof AlgoliaSearchBox> & {
  onLocationPage?: boolean;
};

const AlgoliaSearchBoxWrapper = (props: AlgoliaSearchBoxProps) => {
  const intl = useIntl();

  return (
    <AlgoliaSearchBox
      {...props}
      configs={global.__AT_DATA__.algoliaConfig}
      includeGuides={global.__AT_DATA__.features.includes('guides')}
      navigateOnSelect
      placeholder={intl.formatMessage({ defaultMessage: 'Enter a city, park or trail name' })}
      searchOrigin={props.onLocationPage ? SearchOrigin.LocationPage : undefined}
      testId="algolia-search-box"
    />
  );
};

const AlgoliaSearchBoxErbWrapper = (props: AlgoliaSearchBoxProps) => (
  <CustomProvider>
    <AlgoliaSearchBoxWrapper {...props} />
  </CustomProvider>
);

export default AlgoliaSearchBoxErbWrapper;
